import { render, staticRenderFns } from "./Warranty-insurance.vue?vue&type=template&id=2caea069&"
import script from "./Warranty-insurance.vue?vue&type=script&lang=js&"
export * from "./Warranty-insurance.vue?vue&type=script&lang=js&"
import style0 from "./Warranty-insurance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports